import { memo, useCallback, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { documentHotkeysSelector } from 'domain/documents/documentSelector';
import { journalSelector, selectedRowSelector } from 'domain/journal';
import { hotkeyMatcher } from 'lib/hotkeysHelpers';

import { HotkeyCellListFactory, HotkeyMatchFactory } from 'domain/documents/factories';
import { RecordCellSet } from 'domain/journal/helper';

const OptionalLineHotkeyCatcher = ({ hotkeys, selectedRows, cellsEntry, handleHotkeyMatch }) => {
  const lineHotkeys = useMemo(() => hotkeys.filter((keys) => keys.level === 'optional_line'), [hotkeys]);
  const plugCell = useSelector(journalSelector).first();

  const onHotkeyMatch = useCallback(
    (keys) => {
      const selectedCells = selectedRows.map((row) => `A${row}`);
      const cellList = selectedCells.map((_cell) => {
        const cellEntry = cellsEntry.get(_cell);

        return HotkeyCellListFactory({
          set: RecordCellSet(cellEntry.cellSet),
          name: cellEntry.name,
          cell: _cell,
        });
      });

      // for keyboard shortcuts it doesn't matter which cell is passed to 'update' field,
      // e.g. first 2 handleHotkeyMatch func params. Back-end skips 'update' field if 'hotkey' field is exist
      const cellName = plugCell.get('_cell');
      handleHotkeyMatch(cellName, null, false, HotkeyMatchFactory({ cell_list: cellList, key: keys }));
    },
    [selectedRows, cellsEntry, handleHotkeyMatch, plugCell],
  );

  const handleKeyDown = useCallback(
    (e) => {
      const isMatch = hotkeyMatcher(e, lineHotkeys, onHotkeyMatch);

      if (isMatch) {
        e.preventDefault();
      }
    },
    [lineHotkeys, onHotkeyMatch],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [lineHotkeys, selectedRows, handleKeyDown]);

  return null;
};

const mapStateToProps = (state) => ({
  hotkeys: documentHotkeysSelector(state),
  selectedRows: selectedRowSelector(state),
  cellsEntry: journalSelector(state),
});

export default compose(connect(mapStateToProps))(memo(OptionalLineHotkeyCatcher));
